import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from 'src/app/constants';
import { DashboardService } from 'src/app/services/dashboard.service';
import moment from 'moment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { buildAetUserContext } from 'src/app/core/constant/user-context.util';

@Component({
  selector: 'app-edit-resolution',
  templateUrl: './edit-resolution.component.html',
  styleUrls: ['./edit-resolution.component.scss'],
  standalone: false // NOSONAR
})
export class EditResolutionComponent implements OnInit {

  alertsuccessMessage: any;
  alerterrorMessage: any;
  successMessage: any;
  errorMessage: any;
  addRouteEventForm: FormGroup;
  submitted: boolean;
  toyotaGUID: string;
  statusList: any[] = [];
  resolutionList: any[] = [];
  commentsRequired: boolean = false;
  eventId: any;
  route: any;
  run: any;
  arrival: any;
  destList: any[];
  lpList: any;
  region: any;
  resolutionId: any;
  maxi = 1000;
  ldiv: any = 0;
  payLoad: any;
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly dasboardService: DashboardService,
    private readonly dialog: MatDialog,
    private readonly DatePipe: DatePipe,
    private readonly router: Router,
    public constants: Constants,
    public dialogRef: MatDialogRef<EditResolutionComponent>,
    @Inject(MAT_DIALOG_DATA) public dataStore: any,
  ) { }

  ngOnInit(): void {
    this.submitted = false;
    this.toyotaGUID = '';
    this.toyotaGUID = localStorage.getItem('toyotaGUID');
    this.resolutionId = this.dataStore.resolInfo.resolution_id
    this.creareSafetyRouteForm();
    this.setupResolutionWizard(this.resolutionId);
    this.alertsuccessMessage = null
    this.alerterrorMessage = null
  }

  get form() {
    return this.addRouteEventForm.controls;
  }
  creareSafetyRouteForm() {

    this.addRouteEventForm = this.formBuilder.group({
      resolutionType: ['', [Validators.required]],
      reassignRouteName: [''],
      plannedUnload: [''],
      status: ['', Validators.required],
      loadNumber: [''],
      destination: [''],
      logisticsPartner: [''],
      logisticsPartnerName: [''],
      etaDate: [''],
      pickUpDate: [''],
      dispatchDate: [''],
      etaTime: [''],
      pickUpTime: [''],
      dispatchTime: [''],
      trailer: [''],
      commentsInput: [''],
    });
  }
  year_format1 = 'YYYY-MM-DD'
  async setupResolutionWizard(resolutionId) {
    await this.dasboardService
      .loadingDropdownsforEdit(resolutionId)
      .then(
        (x) => {
          this.resolutionList = [];
          if (x.resolutionTypes && x.resolutionTypes.length > 0) {
            x.resolutionTypes.forEach((element) => {
              this.resolutionList.push({ label: element.resolutionId, value: element.description });
            });
            const sorted = [...this.resolutionList];

            sorted.sort((a, b) => {
              const valueA = a.value?.toLowerCase() ?? '';
              const valueB = b.value?.toLowerCase() ?? '';

              if (valueA < valueB) {return -1};
              if (valueA > valueB) {return 1;}
              return 0;
            });

            this.resolutionList = sorted;
          }
          this.statusList = [];
          if (x.resolutionStatuses && x.resolutionStatuses.length > 0) {
            x.resolutionStatuses.forEach((element) => {
              this.statusList.push({ label: element.statusId, value: element.description });
            });
            const sorted = [...this.statusList];

            sorted.sort((a, b) => {
              const valueA = a.value?.toLowerCase() ?? '';
              const valueB = b.value?.toLowerCase() ?? '';

              if (valueA < valueB) {return -1};
              if (valueA > valueB) {return 1;}
              return 0;
            });

            this.statusList = sorted;
          }
          this.destList = [];
          if (x.destinations && x.destinations.length > 0) {
            x.destinations.forEach((element) => {
              this.destList.push({ label: element.itemCode, value: element.itemDesc });
            });
            const sorted = [...this.destList];

            sorted.sort((a, b) => {
              const valueA = a.value?.toLowerCase() ?? '';
              const valueB = b.value?.toLowerCase() ?? '';

              if (valueA < valueB) {return -1};
              if (valueA > valueB) {return 1;}
              return 0;
            });

            this.destList = sorted;

          }
          this.lpList = [];
          if (x.logisticalPartners && x.logisticalPartners.length > 0) {
            x.logisticalPartners.forEach((element) => {
              this.lpList.push({ label: element.vendorId, value: element.shortName });
            });
            const sorted = [...this.lpList];

            sorted.sort((a, b) => {
              const valueA = a.value?.toLowerCase() ?? '';
              const valueB = b.value?.toLowerCase() ?? '';

              if (valueA < valueB) {return -1;}
              if (valueA > valueB) {return 1;}
              return 0;
            });

            this.lpList = sorted;

          }
        },
        (_error) => {
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, 5000);
        }
      );
    this.form['resolutionType'].patchValue(this.dataStore.resolInfo.resolution_type_id);
    this.form['reassignRouteName'].patchValue(this.dataStore.resolInfo.route_name_reassign)
    this.form['plannedUnload'].patchValue(this.dataStore.resolInfo.resolution_type_id)
    this.form['status'].patchValue(this.dataStore.resolInfo.status_id)
    this.form['loadNumber'].patchValue(this.dataStore.resolInfo.load_number)
    if (this.dataStore.resolInfo.destination == -1) { this.form['destination'].patchValue("") }   // NOSONAR
    else { this.form['destination'].patchValue(this.dataStore.resolInfo.destination) }
    if (this.dataStore.resolInfo.transportation_provider_id == -1) { this.form['logisticsPartner'].patchValue(""); }   // NOSONAR
    else { this.form['logisticsPartner'].patchValue(parseInt(this.dataStore.resolInfo.transportation_provider_id)); }
    this.form['logisticsPartnerName'].patchValue(this.dataStore.resolInfo.transportation_name)
    this.form['trailer'].patchValue(this.dataStore.resolInfo.trailer_number)
    this.form['commentsInput'].patchValue(this.dataStore.resolInfo.comments)
    if (this.dataStore.resolInfo.comments == null || this.dataStore.resolInfo.comments == undefined) {   // NOSONAR
      this.ldiv = 0;
    }
    else {
      this.ldiv = this.dataStore.resolInfo.comments?.length;
    }
    //setting Dates and times
    if (this.dataStore.resolInfo.eta != null) { // NOSONAR
      this.form['etaDate'].patchValue(moment.utc(this.dataStore.resolInfo.eta).format(this.year_format1))
      this.form['etaTime'].patchValue(moment.utc(this.dataStore.resolInfo.eta).format('HH:mm'))
    }
    if (this.dataStore.resolInfo.pickup_date != null) { // NOSONAR
      this.form['pickUpDate'].patchValue(moment.utc(this.dataStore.resolInfo.pickup_date).format(this.year_format1))
      this.form['pickUpTime'].patchValue(moment.utc(this.dataStore.resolInfo.pickup_date).format('HH:mm'))
    }
    if (this.dataStore.resolInfo.plan_dispatch != null) { // NOSONAR
      this.form['dispatchDate'].patchValue(moment.utc(this.dataStore.resolInfo.plan_dispatch).format(this.year_format1))
      this.form['dispatchTime'].patchValue(moment.utc(this.dataStore.resolInfo.plan_dispatch).format('HH:mm'))
    }
  }
  checkChange(value: string) {
    this.ldiv = value.length;
  }
  formatDate(inputDate: string, dateType: String) {
    const userInputDate = new Date();

    if (isNaN(userInputDate.getTime())) {
      this.alerterrorMessage = 'Invalid date format. Please provide a valid date in MM/DD/YYYY HH:mm format.'
      return true;
    }

    const oneYearAgo = new Date(userInputDate);
    const oneYearLater = new Date(userInputDate);
    if (dateType == 'ETA') {  // NOSONAR
      oneYearAgo.setDate(userInputDate.getDate() - 5);

      oneYearLater.setDate(userInputDate.getDate() + 15);
    } else {
      oneYearAgo.setFullYear(userInputDate.getFullYear() - 1);
      oneYearLater.setFullYear(userInputDate.getFullYear() + 1);
    }

    const options: Intl.DateTimeFormatOptions = {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };

    const pastDate = oneYearAgo.toLocaleString('en-US', options);
    const futureDate = oneYearLater.toLocaleString('en-US', options);
    const date1Number = monthToComparableNumber(inputDate)
    const date2Number = monthToComparableNumber(pastDate.replace(',', ''))
    const date3Number = monthToComparableNumber(futureDate.replace(',', ''))

    if (date1Number <= date2Number || date1Number >= date3Number) {
      // alert(`Entered ${dateType} must be between ${pastDate.replace(',', '')} and ${futureDate.replace(',', '')}`)
      this.alerterrorMessage = `Entered ${dateType} must be between ${pastDate.replace(',', '')} and ${futureDate.replace(',', '')}`
      return true;
    }
    return false;


  }

  close() {
    this.alerterrorMessage = null;
    this.alertsuccessMessage = null;
  }


  etaChange() {
    this.form['etaTime'].setValue(moment(new Date()).format('HH:mm'))
  }
  pickUpChange() {
    this.form['pickUpTime'].setValue(moment(new Date()).format('HH:mm'))
  }
  PlanDispatchChange() {
    this.form['dispatchTime'].setValue(moment(new Date()).format('HH:mm'))
  }
  onSubmit() { // NOSONAR
    this.submitted = true;

    if (this.form['status'].errors?.['required'] || this.form['resolutionType'].errors?.['required']) {
      return;
    }

    if (this.form['status'].value != "N") { // NOSONAR
      if (!this.form['etaDate'].value) {
        // alert("A resolution that is 'Arrived', 'Closed', 'Confirmed', 'Covered', 'In Transit' must have an ETA. Please Enter an ETA.")
        this.alerterrorMessage = "A resolution that is 'Arrived', 'Closed', 'Confirmed', 'Covered', 'In Transit' must have an ETA. Please Enter an ETA."
        return;
      }
    }
    const year_format = 'MM/dd/yyyy'
    if (this.form['status'].value != "N") { // NOSONAR
      let retType;
      if (this.form['dispatchDate'].value) {
        retType = this.formatDate(this.DatePipe.transform(this.form['dispatchDate'].value, year_format) + ' ' + this.form['dispatchTime'].value, 'plan Dispatch date')
        if (retType) { return; }
      }
      if (this.form['pickUpDate'].value) {
        retType = this.formatDate(this.DatePipe.transform(this.form['pickUpDate'].value, year_format) + ' ' + this.form['pickUpTime'].value, 'Pick Up date')
        if (retType) { return; }
      }
      if (this.form['etaDate'].value) {
        retType = this.formatDate(this.DatePipe.transform(this.form['etaDate'].value, year_format) + ' ' + this.form['etaTime'].value, 'ETA')
        if (retType) { return; }
      }
    }
    if (this.form['status'].value != "N") { // NOSONAR
      if (!this.form['etaDate'].value) {
        // alert("A resolution that is 'Arrived', 'Closed', 'Confirmed', 'Covered', 'In Transit' must have an ETA. Please Enter an ETA.")
        this.alerterrorMessage = "A resolution that is 'Arrived', 'Closed', 'Confirmed', 'Covered', 'In Transit' must have an ETA. Please Enter an ETA."
        return;
      }
      if (!this.form['destination'].value) {
        // alert("Please select a valid destination.")
        this.alerterrorMessage = "Please select a valid destination."
        return;
      }
      if (!this.form['logisticsPartner'].value) {
        // alert("Please select a valid Logistics Partner.")
        this.alerterrorMessage = "Please select a valid Logistics Partner."
        return;
      }
      if (this.form['resolutionType'].value.label == 2 || this.form['resolutionType'].value.label == 3) {   // NOSONAR
        if (!this.form['reassignRouteName'].value || !this.routeFormatCheck()) {
          // alert("Please Enter a valid route (XXX-YY).")
          this.alerterrorMessage = "Please Enter a valid route (XXX-YY)."
          return;
        }
      }
      if (!this.form['loadNumber'].value) {
        // alert("Please enter a load number for resolution.")
        this.alerterrorMessage = "Please enter a load number for resolution."
        return;
      }
    }
    this.eventId = localStorage.getItem('eventId');
    const yrfrmt = 'MM-dd-yyyy'
    this.payLoad = {
      event_id: this.eventId,
      resolution_id: this.dataStore.resolInfo?.resolution_id,
      resolution_type_id: this.form['resolutionType'].value,
      status_id: this.form['status'].value,
      load_number: this.form['loadNumber'].value,
      transportation_provider_id: this.form['logisticsPartner'].value ? this.form['logisticsPartner'].value : "-1",
      transportation_provider_name: this.form['logisticsPartnerName'].value,
      logistics_point: this.form['destination'].value ? this.form['destination'].value : "-1",
      eta: this.form['etaDate'].value ? this.DatePipe.transform(this.form['etaDate'].value, yrfrmt) + ' ' + this.form['etaTime'].value : null,
      trailer_number: this.form['trailer'].value,
      pickup_date: this.form['pickUpDate'].value ? this.DatePipe.transform(this.form['pickUpDate'].value, yrfrmt) + ' ' + this.form['pickUpTime'].value : null,
      plan_dispatch: this.form['dispatchDate'].value ? this.DatePipe.transform(this.form['dispatchDate'].value, yrfrmt) + ' ' + this.form['dispatchTime'].value : null,
      comments: this.form['commentsInput'].value,
      reassignRouteName: this.form['resolutionType'].value == 2 || this.form['resolutionType'].value == 3 ? this.form['reassignRouteName'].value : null,    // NOSONAR
      region: this.region,
      ...buildAetUserContext()
    }
    if (this.form['etaTime'].value != "" || this.form['pickUpTime'].value != "" || this.form['dispatchTime'].value != "") { // NOSONAR
      if (this.form['etaTime'].value != "" && (this.form['etaDate'].value == "" || this.form['etaDate'].value == null)) {    // NOSONAR
        this.alerterrorMessage = null;
        this.alerterrorMessage = "Please Enter ETA Date";
      }
      else if (this.form['pickUpTime'].value != "" && (this.form['pickUpDate'].value == "" || this.form['pickUpDate'].value == null)) {   // NOSONAR
        this.alerterrorMessage = null;
        this.alerterrorMessage = "Please Enter Pickup Date";
      }
      else if (this.form['dispatchTime'].value != "" && (this.form['dispatchDate'].value == "" || this.form['dispatchDate'].value == null)) {    // NOSONAR
        this.alerterrorMessage = null;
        this.alerterrorMessage = "Please Enter Dispatch Date";
      }
      else {
        this.editResolutionApiCall();
      }
    }
    else {
      this.editResolutionApiCall();
    }

  }
  editResolutionApiCall() {
    this.dasboardService.updateResolutions(this.payLoad)?.subscribe((response) => {
      if (response == "success") {    // NOSONAR
        this.dialogRef.close({
          event: "SaveEvent",
          response: response,
          resolution_id: this.resolutionId
        });
      } else {
        this.dialogRef.close({
          event: "failed",
          response: response,
        });
      }
    },
      (_error) => {
        this.dialogRef.close({
          event: "failed"
        });
      })

  }

  routeFormatCheck() {

    const value = this.form['reassignRouteName'].value;
    const s = value.split("-");
    if (s.length != 2) { // NOSONAR
      return false;
    }
    const s2 = (s[0]);
    if (s2.length > 7) {
      return false;
    }
    const s3 = (s[1]);
    if (s3.length > 2) {
      return false;
    }
    return true;
  }

  createValidations() {
    this.successMessage = null;
    this.errorMessage = null;
    let returnVal = true;
    if (this.addRouteEventForm.invalid) {
      returnVal = false;
    }
    return returnVal;
  }
  onCancel() {
    this.dialogRef.close()
  }
}

function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 16) {    // NOSONAR
    return null;
  }
  const minNumber = Number.parseInt(date.substring(14, 16));
  const hourNumber = Number.parseInt(date.substring(11, 13));

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));

  return yearNumber * 100000000 + monthNumber * 1000000 + dayNumber * 10000 + hourNumber * 100 + minNumber;
}
